// extracted by mini-css-extract-plugin
export default {"addFeedbackContainer":"AddFeedback_addFeedbackContainer__5Tm4K","addFeedback":"AddFeedback_addFeedback__fXpyV","actions":"AddFeedback_actions__v+xr0"};